document.addEventListener('DOMContentLoaded', () => {
  const videoMain = document.querySelector('.product_video_main[data-scroll-to-next]');
  if (!videoMain) return;

  const videoSection = videoMain.closest('.shopify-section');

  videoMain.addEventListener('click', () => {
    const allSections = [...document.querySelectorAll('.shopify-section')];
    const currentIndex = allSections.indexOf(videoSection);
    const nextSection = allSections.slice(currentIndex + 1).find(
      (section) => getComputedStyle(section).position !== 'fixed' && section.offsetHeight > 10
    );
    nextSection?.scrollIntoView({ behavior: 'smooth' });
  });
});
